import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/stores/rootStore";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

const ColorSettingTool: React.FC = () => {
    const rootStore = useContext(RootStoreContext);
    const [t] = useTranslation(["browse_page"], translationHookOptions);
    const {
        setBrushConfigColor,
        setBrushConfigLine,
        toolConfig,
      } = rootStore.zwibblerStore;
      const {isMobileMediaQuery } = rootStore.responsiveStore;

    return (
        <>

        <div className={classNames("row", isMobileMediaQuery ? "customRow " : "ml-1")}>
              <div className="col-12 mb-1">{t("toolbar_settings_color_label")}</div>
            <div className={classNames("buttonContainerMobile col-12" )}>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement ml-0")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    toolConfig.color === "black" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "black" }}
                  onClick={() => setBrushConfigColor("black")}>
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    toolConfig.color === "white" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "white" }}
                  onClick={() => setBrushConfigColor("white")}>
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    toolConfig.color === "red" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "red" }}
                  onClick={() => setBrushConfigColor("red")}>
                </button>
                </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    
                    toolConfig.color === "green" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "green" }}
                  onClick={() => setBrushConfigColor("green")}>   
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    
                    toolConfig.color === "blue" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "blue" }}
                  onClick={() => setBrushConfigColor("blue")}>
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    
                    toolConfig.color === "yellow" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "yellow" }}
                  onClick={() => setBrushConfigColor("yellow")}>
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    
                    toolConfig.color === "pink" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "pink" }}
                  onClick={() => setBrushConfigColor("pink")}>
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    
                    toolConfig.color === "#00CCFF" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "#00CCFF" }}
                  onClick={() => setBrushConfigColor("#00CCFF")}>
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    
                    toolConfig.color === "orange" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "orange" }}
                  onClick={() => setBrushConfigColor("orange")}>
                </button>
              </div>
              <div className={classNames(isMobileMediaQuery ? "divColorMobileElement" : "divColorElement")}>
                <button
                  className={classNames(
                    "fas fa-circle IconaCustom",
                    
                    toolConfig.color === "grey" ? `IconaCustonSelected` : ``
                  )}
                  style={{ color: "grey" }}
                  onClick={() => setBrushConfigColor("grey")}>
                </button>
              </div>
            </div>
          </div>
          <div className={classNames("row mt-2", isMobileMediaQuery ? "customRow" : "ml-1")}>
            <div className={classNames(isMobileMediaQuery ? "col-12" : "col-6")}>
              <div>{t("toolbar_settings_stroke_label")}</div>
              <button
                className={classNames(
                  "trattoButton trattoButtonSmall",
                  toolConfig.lineWidth === 3 ? `IconaCustonSelected` : ``
                )}
                onClick={() => setBrushConfigLine(3)}
              ></button>
              <button
                className={classNames(
                  "trattoButton trattoButtonMedium ml-3",
                  toolConfig.lineWidth === 5 ? `IconaCustonSelected` : ``
                )}
                onClick={() => setBrushConfigLine(5)}
              ></button>
              <button
                className={classNames(
                  "trattoButton trattoButtonBig ml-3",
                  toolConfig.lineWidth === 10 ? `IconaCustonSelected` : ``
                )}
                onClick={() => setBrushConfigLine(10)}
              ></button>
            </div>
            <div className="col-6"></div>
          </div>

        </>
    )
  }

  export default observer(ColorSettingTool);
